var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('table', {
    staticClass: "product-table uk-table uk-table-divider uk-table-justify"
  }, [_c('tbody', _vm._l((_vm.products), function(product) {
    return _c('tr', [_c('td', {
      staticClass: "product-table__thumbnail-cell"
    }, [(product.teaserImage) ? _c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [_c('img', {
      attrs: {
        "src": product.teaserImage.thumbImageUrl,
        "alt": product.name
      }
    })]) : _c('text-placeholder')], 1), _vm._v(" "), _c('td', [_c('router-link', {
      attrs: {
        "to": {
          name: 'product',
          params: {
            id: product.id
          }
        }
      }
    }, [(_vm.useVariantNames) ? _c('span', [_vm._v("\n            " + _vm._s(product.variantName || product.name) + "\n          ")]) : _c('span', [_vm._v("\n            " + _vm._s(product.name) + "\n          ")])]), _vm._v(" "), _c('div', {
      staticClass: "uk-text-muted"
    }, [_vm._v("\n          " + _vm._s(product.articleNumber) + "\n        ")])], 1), _vm._v(" "), _c('td', [_c('data-grid-actions', {
      attrs: {
        "edit-route": {
          name: 'edit-product',
          params: {
            id: product.id
          }
        },
        "removable": false
      }
    })], 1)])
  }))])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-92f339cc","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./components/ProductTable.vue
// module id = 2083
// module chunks = 0